import {
  AcceptanceFormPage,
  CskhPage,
  DanhSachThiPage,
  FoThucDonLayout,
  He,
  HocSinhLayout,
  HocSinhPhuHuynhPage,
  HomePage,
  Khoi,
  KhoiHePage,
  KyThi,
  KyThiMonThi,
  LoaiGiayTo,
  Lop,
  LopHanhChinhPage,
  MonThi,
  NguonBietToiLayout,
  NguonBietToiPage,
  NoiTruLayout,
  PhongThiPage,
  PhuHuynhPage,
  SendEmailLayout,
  SucKhoeLayout,
  SurveyForm,
  SurveyLayout,
  ThangDiem,
  ThiSinh,
  ThongKePage,
  ThongTinCbnvPage,
  TongHopLayout,
  Truong,
  ThoiHocBaoLuu,
  MonThiDauVaoPage,
  ThiDauVaoPage,
  TrangThaiThiSinhPage,
  KetQuaThiDauVaoPage,
  ThiTuyenSinhLayout,
  QuanLyHoTroLayout,
  AppYeuCauHoTroPage,
  AppYeuCauHoTroDetailPage,
  QuanHePage,
  LoaiThuocPage,
  ChuyenKhoaPage,
  BaoCaoYTePage,
  TinhTrangHonNhanPage,
  TinhNew,
  HotlinePage
} from './pages';
import BHYTPage from './pages/bhyt';
import DonViTinhThuocPage from './pages/category/don-vi-tinh-thuoc/DonViTinhThuocPage';
import KhoThuocPage from './pages/category/kho-thuoc';
import DanThuocPage from './pages/dan-thuoc';
import Faceid from './pages/face-id';
import LichSuXuongPhongYTe from './pages/lich-su-y-te';
import LichSuYTeTypePage from './pages/lich-su-y-te-type/LichSuYTeTypePage';
import TongHopGiayTo from './pages/tong-hop-giay-to';
import TongHopSucKhoe from './pages/tong-hop-suc-khoe';
import TongHopChieuCaoCanNang from './pages/tong-hop-chieu-cao-can-nang';
import ChieuCaoCanNangPage from './pages/sis/chieu-cao-can-nang/ChieuCaoCanNangPage';



const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/dashboard",
    component: ThongKePage,
  },
  {
    path: "/ds_hoc_sinh_lop/:tab?",
    component: LopHanhChinhPage,
  },


  {
    path: "/crm_survey/form/:id",
    component: SurveyForm,
  },
  {
    path: "/crm_survey/:tab?",
    component: SurveyLayout,
  },

  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiLayout,
  },
  {
    path: "/dm_trangthaihocsinh/:tab?",
    component: HocSinhPhuHuynhPage,
  },
  {
    path: "/loai_giay_to/:tab?",
    component: LoaiGiayTo,
  },
  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiPage,
  },
  {
    path: "/send-email/:tab?",
    component: SendEmailLayout,
  },
  {
    path: "/hoc-sinh/:tab?",
    component: HocSinhLayout,
  },
  {
    path: "/food/:tab?",
    component: FoThucDonLayout,
  },
  {
    path: "/phu-huynh/:tab?",
    component: PhuHuynhPage,
  },
  {
    path: "/acceptance-form/:tab?",
    component: AcceptanceFormPage,
  },
  {
    path: "/truong/:tab?",
    component: Truong,
  },
  {
    path: "/tinh-new/:tab?",
    component: TinhNew,
  },
  {
    path: "/he/:tab?",
    component: He,
  },
  {
    path: "/khoi/:tab?",
    component: Khoi,
  },
  {
    path: "/khoi_he/:tab?",
    component: KhoiHePage,
  },
  {
    path: "/lop/:tab?",
    component: Lop,
  },
  {
    path: "/suc-khoe/:tab?",
    component: SucKhoeLayout,
  },
  {
    path: "/thang-diem/:tab?",
    component: ThangDiem,
  },
  {
    path: "/mon-thi/:tab?",
    component: MonThi,
  },
  {
    path: '/ky-thi/:tab?',
    component: KyThi
  },
  {
    path: '/thongtin-cbnv/:tab?',
    component: ThongTinCbnvPage,
  },
  {
    path: "/ky-thi",
    component: KyThi,
  },
  {
    path: "kythi-monthi/:tab?",
    component: KyThiMonThi,
  },
  {
    path: "thi-sinh/:tab?",
    component: ThiSinh,
  },
  {
    path: "danh-sach-thi/:tab?",
    component: DanhSachThiPage,
  },
  {
    path: "phong-thi/:tab?",
    component: PhongThiPage,
  },

  {
    path: "/noi-tru/:tab?",
    component: NoiTruLayout,
  },
  {
    path: "/tong-hop/:tab?",
    component: TongHopLayout,
  },

  {
    path: "/tong-hop-giay-to/:tab?",
    component: TongHopGiayTo,
  },
  {
    path: "/face-id/:tab?",
    component: Faceid,
  },
  {
    path: "/cskh/:tab?",
    component: CskhPage,
  },
  {
    path: "/thong-ke",
    component: ThongKePage,
  },
  {
    path: "/thoi-hoc-bao-luu",
    component: ThoiHocBaoLuu,
  },
  {
    path: "/monthidauvao/:tab?",
    component: MonThiDauVaoPage,
  },
  {
    path: "/thidauvao/:tab?",
    component: ThiDauVaoPage,
  },
  {
    path: "/ex_trangthai_thisinh/:tab?",
    component: TrangThaiThiSinhPage,
  },
  {
    path: "/ketqua-thidauvao/:tab?",
    component: KetQuaThiDauVaoPage,
  },
  {
    path: "/thi-tuyen-sinh/:tab?",
    component: ThiTuyenSinhLayout,
  },
  {
    path: "/quan-ly-ho-tro/:tab?",
    component: QuanLyHoTroLayout,
  },
  {
    path: "/app-yeu-cau-ho-tro",
    component: AppYeuCauHoTroPage,
  },
  {
    path: "/app-yeu-cau-ho-tro/:id",
    component: AppYeuCauHoTroDetailPage,
  },
  {
    path: "/quan-he/:tab?",
    component: QuanHePage,
  },
  {
    path: "/loai-thuoc/:tab?",
    component: LoaiThuocPage,
  },
  {
    path: "/don-vi-tinh-thuoc/:tab?",
    component: DonViTinhThuocPage,
  },
  {
    path: "/chuyen-khoa/:tab?",
    component: ChuyenKhoaPage,
  },
  {
    path: "/bao-cao-y-te/:tab?",
    component: BaoCaoYTePage,
  },
  {
    path: "/tinh-trang-hon-nhan/:tab?",
    component: TinhTrangHonNhanPage,
  },
  {
    path: "/hotline/:tab?",
    component: HotlinePage,
  },
  {
    path: "/bhyt/:tab?",
    component: BHYTPage,
  },
  {
    path: "/lich-su-xuong-phong-y-te/:tab?",
    component: LichSuXuongPhongYTe,
  },
  {
    path: "/tong-hop-suc-khoe/:tab?",
    component: TongHopSucKhoe,
  },
  {
    path: '/dan-thuoc',
    component: DanThuocPage
  },
  {
    path: "/lich-su-y-te-type/:tab?",
    component: LichSuYTeTypePage,
  },
  {
    path: "/kho-thuoc/:tab?",
    component: KhoThuocPage,
  },
  {
    path: "/chieu-cao-can-nang",
    component: ChieuCaoCanNangPage,
  },
  {
    path: "/tong-hop-chieu-cao-can-nang/:tab?",
    component: TongHopChieuCaoCanNang,
  },
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
